"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const chunk_1 = __importDefault(require("lodash/chunk"));
const url_1 = __importDefault(require("url"));
const live_env_1 = require("@ledgerhq/live-env");
const promise_1 = require("../../promise");
const helpers_1 = require("../helpers");
const baseURL = () => (0, live_env_1.getEnv)("LEDGER_COUNTERVALUES_API");
const LATEST_CHUNK = 50;
const latest = (pairs, direct) => __awaiter(void 0, void 0, void 0, function* () {
    const all = yield (0, promise_1.promiseAllBatched)(4, (0, chunk_1.default)(pairs, LATEST_CHUNK), (partial) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `${baseURL()}/v2/latest/${direct ? "direct" : "indirect"}?pairs=${partial
            .map(p => (0, helpers_1.encodePairAsLedgerIdPair)(p.from, p.to))
            .join(",")}`;
        const { data } = yield (0, network_1.default)({ method: "GET", url });
        return data;
    }));
    const data = all.reduce((acc, data) => acc.concat(data), []);
    return data;
});
// to have more determinism in the order of the pairs requested to the API
const sortTrackingPair = (a, b) => (0, helpers_1.encodePairAsLedgerIdPair)(a.from, a.to).localeCompare((0, helpers_1.encodePairAsLedgerIdPair)(b.from, b.to));
const api = {
    fetchHistorical: (granularity, { from, to, startDate }) => __awaiter(void 0, void 0, void 0, function* () {
        const format = helpers_1.formatPerGranularity[granularity];
        const query = {};
        if (startDate) {
            query.start = format(startDate);
        }
        if (to.type !== "FiatCurrency") {
            // for anything else than fiat, we use direct
            query.method = "direct";
        }
        const url = url_1.default.format({
            pathname: `${baseURL()}/v2/${granularity}/${(0, helpers_1.encodeCurrencyAsLedgerId)(from)}/${to.ticker}`,
            query,
        });
        const { data } = yield (0, network_1.default)({ method: "GET", url });
        return data;
    }),
    fetchLatest: (pairs) => __awaiter(void 0, void 0, void 0, function* () {
        // spliting the direct and indirect
        const directP = [];
        const indirectP = [];
        pairs.forEach(p => {
            if (p.to.type !== "FiatCurrency") {
                directP.push(p);
            }
            else {
                indirectP.push(p);
            }
        });
        directP.sort(sortTrackingPair);
        indirectP.sort(sortTrackingPair);
        const [direct, indirect] = yield Promise.all([
            directP.length ? latest(directP, true) : Promise.resolve([]),
            indirectP.length ? latest(indirectP) : Promise.resolve([]),
        ]);
        const data = Array(pairs.length).fill(0);
        directP.forEach((p, i) => {
            data[pairs.indexOf(p)] = direct[i];
        });
        indirectP.forEach((p, i) => {
            data[pairs.indexOf(p)] = indirect[i];
        });
        return data;
    }),
    fetchMarketcapTickers: () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield (0, network_1.default)({
            method: "GET",
            url: `${baseURL()}/v2/tickers`,
        });
        return data;
    }),
};
exports.default = api;
//# sourceMappingURL=api.js.map